import { IntlProvider, addLocaleData } from "react-intl";
import en from "react-intl/locale-data/en";
import es from "react-intl/locale-data/es";
import messages from "../locale/index";
import { flattenMessages } from "../utils/helper";
import { getStore } from "../store/configureStore";

addLocaleData([...en, ...es]);
window.intl = {
  formatMessage: (data) => {
    return data.id;
  }
};
let prevLang = "en";
const updateIntlProv = (lang = "en") => {
  //const msgs = flattenMessages(messages[lang]);
  const msgs = {...flattenMessages(messages["en"]), ...flattenMessages( messages[lang])}      
  const intlProvider = new IntlProvider({ locale: lang, messages: msgs });
  const { intl } = intlProvider.getChildContext();
  window.intl = intl;
  prevLang = lang;
};
updateIntlProv();

const store = getStore();
store.subscribe(() => {
  // const lang = ((state.auth || {}).user || {}).lang || "en";
  let lang_ls = localStorage.getItem("lang");
  lang_ls = lang_ls == null ? "en" : lang_ls;  
  const lang = lang_ls || "es";
  if(prevLang !== lang) {
    if (lang === "es"){
      window.gtag("event", "spanish", {
        send_to: "G-F4KZHDWJEE",
      });
    }
    updateIntlProv(lang);
  }
});

export default window.intl;
export {
        updateIntlProv
      };
